import Layers from "slotworks/graphics/layers/layers";

import settingsModel from "slotworks/model/settings/settings-model";
import deviceInfo from "slotworks/utils/device-info";

class PortraitMessagesComponent {

    private active: boolean = false;

    private longerMatch3: string[] = [ "de" ];
    private longerFs: string[] = [ "lv", "ru", "th", "tr", "vi" ];

    public start() {
        this.active = true;
        Layers.Custom.get("Messages").onSceneEnter.add((scene: string) => {
            if(scene && scene.includes("default")) {
                setTimeout(() => this.unifyTextSize(), 10);
            }
        });
        deviceInfo.onLayoutChange.add(() => this.unifyTextSize(), 10);
        this.setDefault();
    }

    public setFreespins() {
        if(this.active) {
            const scene = this.isTwoLinesLanguage() ? "freespins_2lines" : "freespins" ;
            Layers.Custom.get("Messages").setScene(scene).execute();
        }
    }

    public setDefault() {
        if(this.active) {
            if(this.longerFs.indexOf(settingsModel.language) >= 0) {
                Layers.Custom.get("Messages").setScene("default_fs").execute();
            } else if(this.longerMatch3.indexOf(settingsModel.language) >= 0) {
                Layers.Custom.get("Messages").setScene("default_match3").execute();
            } else {
                Layers.Custom.get("Messages").defaultScene().execute();
            }
        }
    }

    public show() {
        if(this.active) {
            Layers.Custom.get("Messages").show();
        }
    }

    public hide() {
        if(this.active) {
            Layers.Custom.get("Messages").hide();
        }
    }

    private isTwoLinesLanguage() {
        return settingsModel.language == "ru" || settingsModel.language == "tr";
    }

    private unifyTextSize() {
        const fstext = Layers.Custom.get("Messages").getText("fstext") as any;
        const match3text = Layers.Custom.get("Messages").getText("match3text") as any;
        if(fstext && match3text) {
            fstext.dirty = true;
            match3text.dirty = true;
            fstext.updateText();
            match3text.updateText();
            const max = Math.max(fstext.fontSizeDecrement, match3text.fontSizeDecrement);
            if(max && typeof max === "number") {
                fstext.fontSizeDecrement = max;
                match3text.fontSizeDecrement = max;
                fstext.dirty = true;
                match3text.dirty = true;
                fstext.updateText();
                match3text.updateText();
            }
        }
    }

}

const PortraitMessages = new PortraitMessagesComponent();
export default PortraitMessages;


// WEBPACK FOOTER //
// ./src/components/messages/portrait-messages.ts